/// <summary>
/// This visual provides a list of all media provided by a project id.<br/>
/// </summary>    ///
/// <remarks>
/// Author: TDA<br/>
/// Date: 03.07.2024<br/>
/// Copyright ©: EUDT GmbH 2024 <br/>
/// Version-History:<br/>
/// **********************************************************************<br/>
/// *** v1.0.0 - 29.04.2024/11.11.2024                                 ***<br/>
/// **********************************************************************<br/>
/// * - generates basic functionality for document and media listing     *<br/>
/// **********************************************************************<br/>
jQuery.widget("bluaul.DocsList", jQuery.common.vcBaseV4, {
    popupUpload: null,
    popupEmail: null,

    myStatus: {
        mediaCategory: "",
        isAdmin: false,
        userRights: null,
        isEditable: false,
        dateRange: { from: "", to: "" }
    },

    _create: function () {
        this._createVisual(361);
        this._super();
    },

    _initHTML: function () {
        var me = this;
        try {
            me._setRoot(".vc-docs-list");

            me.myStatus.mediaCategory = "REPORT";
            //we start with the last day we found any entries
            me.myStatus.dateRange.from = moment(Date.now()).add(-180, 'days').format("DD.MM.YYYY");
            me.myStatus.dateRange.to = moment(Date.now()).format("DD.MM.YYYY");

            me.myStatus.userRights = JSON.parse(me.specific.userRights);
            me.myStatus.isAdmin = JSON.parse(me.specific.isAdmin);

            me._buildHtml();

            me._setHeights();

        } catch (e) {me._writeErr(e);return false; }
        return true;
    },

    _initEvents: function () {
        var me = this;
        try {

            // initialize the date and task box
            me._initStructure();

            me._fetch();

        } catch (e) {me._writeErr(e);return false;}
        return true;
    },

    _buildHtml: function () {
        /// <summary>
        /// This function builds the html structure
        /// </summary>
        var me = this;
        try {

            me.myHtml = { menu: {}, filter: {}, list: {}, topMenu: {}};
            //top menu with the different medio category buttons
            let obj = me.myHtml.topMenu;
            obj.wrapper = me._setWrapper("", "top-menu menu-bar");

            let strInitMediaCategory = "";
            if (typeof me.myStatus.userRights.REPORT !== 'undefined') {
                obj.btn1 = me._setObj("", "button-toggle vc-grid-2col float-box").data("type", "REPORT").html(me.myStatus.userRights.REPORT.name);
                if (strInitMediaCategory === "") {
                    strInitMediaCategory = "REPORT";
                    obj.btn1.addClass("button-toggle-active");
                }
            }
            if (typeof me.myStatus.userRights.OTHERDOCS !== 'undefined') {
                obj.btn2 = me._setObj("", "button-toggle vc-grid-2col float-box").data("type", "OTHERDOCS").html(me.myStatus.userRights.OTHERDOCS.name);
                if (strInitMediaCategory === "") {
                    strInitMediaCategory = "OTHERDOCS";
                    obj.btn2.addClass("button-toggle-active");
                }
            }
            if (typeof me.myStatus.userRights.TV !== 'undefined') {
                obj.btn3 = me._setObj("", "button-toggle vc-grid-2col float-box").data("type", "TV").html(me.myStatus.userRights.TV.name);
                if (strInitMediaCategory === "") {
                    strInitMediaCategory = "TV";
                    obj.btn2.addClass("button-toggle-active");
                }
            }
            //if (typeof me.myStatus.userRights.PRIVATE !== 'undefined') {
            //    obj.btn4 = me._setObj("", "button-toggle vc-grid-1col float-box").data("type", "PRIVATE").html(me.myStatus.userRights.PRIVATE.name);
            //    if (strInitMediaCategory === "") {
            //        strInitMediaCategory = "PRIVATE";
            //        obj.btn2.addClass("button-toggle-active");
            //    }
            //}
            me.myStatus.mediaCategory = strInitMediaCategory;
            obj.wrapper.append(obj.btn1, obj.btn2, obj.btn3, obj.btn4);

            //menu with reload and vcDate
            obj = me.myHtml.menu;
            obj.wrapper = me._setWrapper("", "menu").css("overflow", "visible"); // TODO: Discuss overflow hidden hiding date picker
            obj.reload = me._setMainButton("reload", me.specific.resources.iconReload, me.specific.resources.reload).addClass("active");
            obj.date = me._setObj("date", "optionbox vc-grid-2col float-box");
            obj.wrapper.append(obj.reload, obj.date);

            //filter with new button
            obj = me.myHtml.filter;
            obj.wrapper = me._setWrapper("", "");
            obj.filter = me._setObj("filter", "vc-filter vc-grid-2col float-box");
            obj.wrapper.append(obj.filter);

            if (typeof me.myStatus.userRights[me.myStatus.mediaCategory] !== 'undefined') {
                let lblBtnNew = $('<span></span>');
                lblBtnNew.text(me.specific.resources.lblNew).css("padding", "");
                lblBtnNew.addClass("ui-button-text");
                obj.btnNew = me._setObj("", "ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only float-box").data("type", "NEW").html(lblBtnNew).css("float", "right").css("margin-right", "1vw");
                obj.wrapper.append(obj.btnNew);
            }

            //list area with list header
            obj = me.myHtml.list;
            obj.wrapper = me._setWrapper("", "vc-list");
            obj.header = me._setListHeader("");
            // generate header list
            var line = me._setListItem();
            line.column.append(me._setListElement("", "w10").html(me.specific.resources.actionIcons));
            line.column.append(me._setListElement("", "w20").html(me.specific.resources.fileName));
            line.column.append(me._setListElement("", "w10").html(me.specific.resources.date));
            line.column.append(me._setListElement("", "w40").html(me.specific.resources.description));
            obj.header.append(line.item);

            obj.entries = me._setObj("entries", "vc-list-table");
            obj.wrapper.append(obj.header, obj.entries);


            me.myRoot.append(me.myHtml.topMenu.wrapper, me.myHtml.menu.wrapper, me.myHtml.filter.wrapper, me.myHtml.list.wrapper);

        } catch (e) {me._writeErr(e);return false; }
        return true;
    },
    _initStructure: function () {
        /// <summary>
        /// This function inits various events and handlers
        /// </summary>
        var me = this;
        try {

            me.myHtml.filter.filter.vcFilter({ callback: function () { me._filter(); } });

            // popup for uploading / editing media
            me.popupUpload = $("<div>").attr("id", "popupMediaDialog").css("overflow-y", "hidden").dialog({
                open: function (event, ui) { },
                autoOpen: false, modal: true, width: 980, height: 550,
                resizable: false, dialogClass: "modal-popup-dialog", title: "", closeOnEscape: true, position: { my: 'top+20%', at: 'top', of: window },
                buttons: [{
                    text: window._RESOURCES.JS_Com.close_lbl,
                    click: function () { me.popupUpload.dialog('close'); me._fetch(); return true; }
                }]
            });

            ////email popup
            me.popupEmail = $("<div>").attr("id", "popupEmailDialog").css("overflow-y", "hidden").dialog({
                open: function (event, ui) { },
                autoOpen: false, modal: true, width: 820, height: 770,
                resizable: false, dialogClass: "modal-popup-dialog", title: "", closeOnEscape: true, position: { my: 'top+20%', at: 'top', of: window },
                buttons: [{
                    text: window._RESOURCES.JS_Com.close_lbl,
                    click: function () { me.popupEmail.dialog('close'); return true; }
                }]
            });
           

            //init vcDate
            me.myHtml.menu.date.vcDateBox({ mode: "Range", align: "right", interval: 1, langID: me.settings.userLangIDForCulture, defaultRange: me.myStatus.dateRange, callback: function (obj) { me.myStatus.dateRange = obj.dateRange; } });


             //init the menu click handler
            me.myHtml.topMenu.wrapper.find(".button-toggle").button().off("click").on("click", function () {
                let obj = $(this);
                me.myStatus.mediaCategory = obj.data("type");
                me.myHtml.topMenu.wrapper.find(".button-toggle").removeClass("button-toggle-active");
                obj.addClass("button-toggle-active");

                me._fetch();

            });

            //init buttons
            me.myHtml.menu.reload.off("click").on("click", function () { me._fetch(); });
            me.myHtml.filter.btnNew.off("click").on("click", function () { return me._openUploadPopup(-1);});
            me.myHtml.list.entries.off("click", '.btn-download').on("click", '.btn-download', function (e) { downloadMediaDataUrl($(e.target).data("path"));});
            me.myHtml.list.entries.off("click", '.btn-email').on("click", '.btn-email', function (e) {me._openEmailPopup($(e.target).data('id'));});
            me.myHtml.list.entries.off("click", '.btn-edit').on("click", '.btn-edit', function (e) {me._openUploadPopup($(e.target).data('id'));});


        } catch (e) { me._writeErr(e); }
    },

    _openEmailPopup: function (id) {
        /// <summary>
        /// This function opens the email widget to the popup dif
        /// </summary>
        var me = this;
        try {

            me.vcV.addVisualBaseByName("popupE", 'WIDGET_EMAIL_GALLERY', 'mailDialog', getCurrentTimestamp(), 750, 800, "", JSON.stringify({ 'atid': id, 'isInstall': false, 'divname': -1 }), 1,
                function () { $("#popupEmailDialog").find("#btnBackEmail").hide(); }
            );

            return me.popupEmail.dialog('open');

        } catch (e) { me.writeError(e); return false; }
        return true;
    },

    _openUploadPopup: function (id) {
        /// <summary>
        /// This function opens the upload widget to the popup dif
        /// </summary>
        var me = this;
        try {
            var visualName = "WIDGET_GALLERY_UPLOAD";
            if (me.myStatus.mediaCategory == "PRIVATE") { visualName += "_PRIVATE"; }

            me.vcV.addVisualBaseByName("popupM", visualName, 'ediaDialog',getCurrentTimestamp(), 550, 960,JSON.stringify({ mediaCategory: me.myStatus.mediaCategory, editable: true }),JSON.stringify({ 'mediaId': id }), 1,
                function () { $("#popupMediaDialog").find("#btnBackUpload").hide(); });
            me.popupUpload.dialog('open');

        } catch (e) { me.writeError(e); return false; }
        return true;
    },

    _fetch: function () {
        /// <summary>
        /// This function fetches the data based on the current setings
        /// </summary>
        var me = this;
        try {
            me._setLoadingIcon(me.myHtml.list.entries);

            //get the current edit state
            $.each(me.myStatus.userRights, function (key, row) {
                if (key == me.myStatus.mediaCategory) { me.myStatus.isEditable = row.editable; }
            });

            if (me.myStatus.isEditable) {
                me.myHtml.filter.btnNew.show();
            } else {
                me.myHtml.filter.btnNew.hide();
            }

            var param = { TypeId: 1, StartDate: me.myStatus.dateRange.from, EndDate: me.myStatus.dateRange.to, MediaCategory: me.myStatus.mediaCategory }
            me.getData(param, function (result) {

                //check response content
                if (result == null) {
                    me.showMessage(me.resources.err_loadData, true); // TODO
                    return true;
                }
                me.myData = result;

                me._generateList();
            });

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    _generateList: function () {
        /// <summary>
        /// This function generates a list from the data
        /// </summary>
        var me = this;

        try {

            if (me.myData.length == 0) {
                me.myHtml.list.entries.html($("<br>")).append($("<div>").addClass("note").html(me.resources.noEntriesExist));
                return false;
            }

            //clear list
            me.myHtml.list.entries.html("");

            // fill entry list
            $.each(me.myData, function (key, row) { me.myHtml.list.entries.append(me._fillRow(row)); });

            me._filter();

            return true;

        } catch (e) { me._writeErr(e);return false;}
    },

    _fillRow: function (row) {
        /// <summary>
        /// This function fills the list with all corresponding items
        /// </summary>
        var me = this;
        try {
            var line = me._setListItem();
          
            // Action Icons Col
            var actionCol = me._setListElement("", "w6");
            var downloadBtn = $("<div>").addClass("btn-download btn-table fa-solid fa-download color-font-secondary").attr("title", me.specific.resources.download).html("").data("path", row.Path);
            var emailBtn = $("<div>").addClass("btn-email btn-table fa-solid fa-envelope color-font-secondary").attr("title", me.specific.resources.email).html("").data("id", row.ID);
            var editBtn = $("<div>");
            if (me.myStatus.isEditable) {
                editBtn.addClass("btn-edit btn-table fa-solid fa-edit color-font-secondary").attr("title", me.specific.resources.edit).data("id", row.ID);
            } else {
                editBtn.html("<br/>");
            }
            line.column.append(me._setListElement("", "w2").html(downloadBtn));
            line.column.append(me._setListElement("", "w2").html(emailBtn));
            line.column.append(me._setListElement("", "w2").html(editBtn));
            line.column.append(me._setListElement("", "w3").html(me._getFileIcon(row.FileType)));
            line.column.append(me._setListElement("", "w20").html(row.Name));
            line.column.append(me._setListElement("", "w10").html(moment(row.Timestamp, "DD.MM.YYYY HH:mm").format("DD.MM.YYYY HH:mm")));
            
            // The description varies between admin and standard user view
            //for admins only we add the exact path of the file
            let text = row.Description.endsWith("<br/>") ? row.Description.substring(0, row.Description.lastIndexOf("<br/>")) : row.Description ;
           
            var descLine = me._setListElement("", "w40").html(text);
            if (me.myStatus.isAdmin) {
                var adminPath = "(" + row.Path + ")";

                if (text.length > 0) descLine.append("<br\>");
                descLine.append(me._setListElement("", "admin-path").html(adminPath));
            }

            if (!row.MediaFileExists) {
                //$(line).hide();
                descLine.append("<br>");
                descLine.append(me._setListElement("", "error vc-grid-3col").html(me.specific.resources.errFileNotFound));
                downloadBtn.addClass("btn-table-disabled");
                emailBtn.addClass("btn-table-disabled");
                editBtn.addClass("btn-table-disabled");
            }
            // If there is no file deactivate the buttons
            line.column.append(descLine);
            
            return line.item;
        } catch (e) {me._writeErr(e); return false; }
    },


    _getFileIcon: function (type) {
        /// <summary>
        /// This function fills the list with all corresponding items
        /// </summary>
        var me = this;
        try {
           
            var format = "";
            switch (type) {
                case "pdf": format = "-pdf"; break;
                case "xlsx": format = "-excel"; break;
                case "xls": format = "-excel"; break;
           
            }
            return "<i class='file-icon color-font-secondary fa-solid fa-file" + format + "'></i>";

        } catch (e) { me.writeError(e); return false; }
    },


    _filter: function () {

        this._doListTableFilter(this.myHtml.list.entries);
    },



    _fillItems: function (i) {
        /// <summary>
        /// This function fills the list with all corresponding items
        /// </summary>
        var me = this;
        try {
            let obj = null;
            var item = $("<div>", { "class": "vc-list-item" });

            obj = me.myData;
            item.append($("<div>", { "class": "vc-list-col col0" }).html($("<div>", { "class": "vc-list-col-element" })));
            item.append($("<div>", { "class": "vc-list-col col1" }).html($("<div>", { "class": "vc-list-col-element", "html": me._getDateVals(obj.rows[i].name) })));
            item.append($("<div>", { "class": "vc-list-col col2" }).html($("<div>", { "class": "vc-list-col-element", "html": me._getDateVals(obj.rows[i].timestamp) })));
            item.append($("<div>", { "class": "vc-list-col col3" }).html($("<div>", { "class": "vc-list-col-element", "html": me._getDateVals(obj.rows[i].description) })));

            return item;

        } catch (e) { me.writeError(e); return false; }
    },

    _getDateVals: function (sDate) {
        var me = this;
        try {

            return moment(sDate).format("DD.MM.YYYY");
            // updates the shown date format depending on monthly or daily basis
            //if (me.myData.period == 1)
            //    return $.datepicker.formatDate('dd.mm.yy', me.myData.rows[i].timestamp.day);
            //else
            //    return $.datepicker.formatDate('MM yy', me.myData.rows[i].timestamp.month);

        } catch (e) { me.writeError(e); return false; }
    },

    _calculateDiff: function (i) {
        var me = this;
        try {

            if (i == 0)
                return 0;
            else
                return me.myData.rows[i].zst - me.myData.rows[i - 1].zst;

        } catch (e) { me.writeError(e); return false; }
    },

    _setHeights: function () {
        /// <summary>
        /// This function calculates and sets the height of elements relatively to the general content height
        /// </summary>
        var me = this;
        try {

            let hList = me._getVisualHeight() - me.myHtml.topMenu.wrapper.outerHeight() - me.myHtml.menu.wrapper.outerHeight() - me.myHtml.filter.wrapper.outerHeight() - 20;

            me.myHtml.list.wrapper.css("height", hList);
            hList -= me.myHtml.list.header.outerHeight();
            me.myHtml.list.entries.css("max-height", hList);

        } catch (e) { me._writeErr(e); }
    },

    specificInfoHandling: function (bError) {
        var me = this;
        try {
            if (bError) {
              
                me.myHtml.menu.hide();
                me.myHtml.filter.hide();
                me.myHtml.list.hide();
                me.myHtml.topMenu.hide();
               
            }
            return true;
        } catch (e) {
            me.writeError(e); return false;
        }
    }
});